import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  input: {
    '& .MuiFilledInput-input': {
      fontSize: '0.75rem',
      paddingBottom: '5px',
      paddingLeft: '7px'
    }
  }
}));
